/**
 * useUserPerformance - Hook for fetching user performance data
 */

import { useCallback } from 'react';
import { useApi } from './useApi';
import { getUserByAddress } from '../api/services/userService';

/**
 * Hook to fetch and manage user performance data by wallet address
 * @param {string} userAddress - User's wallet address
 * @param {Object} options - Configuration options
 * @param {boolean} options.immediate - Fetch immediately on mount (default: false)
 * @param {Function} options.onSuccess - Callback on success
 * @param {Function} options.onError - Callback on error
 * @returns {Object} - { performanceData, loading, error, refetch }
 */
export const useUserPerformance = (userAddress, options = {}) => {
  const {
    immediate = false,
    onSuccess,
    onError,
  } = options;

  const fetchPerformance = useCallback(
    () => getUserByAddress(userAddress),
    [userAddress]
  );

  const { data, loading, error, execute, reset } = useApi(fetchPerformance, {
    immediate: immediate && !!userAddress, // Only fetch immediately if address is available
    initialData: null,
    onSuccess,
    onError,
  });

  return {
    performanceData: data,
    loading,
    error,
    refetch: execute,
    reset,
  };
};

export default useUserPerformance;
